export default __webpack_public_path__ + "static/media/tickets_outline-01.001bba8d.svg";